import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'

// Basic selectors
export const selectServicesState = (state: RootState) => state.services
export const selectServices = (state: RootState) => state.services.items
export const selectSelectedService = (state: RootState) => state.services.selectedService
export const selectServicesLoading = (state: RootState) => state.services.loading
export const selectServicesError = (state: RootState) => state.services.error
export const selectServicesFilterParams = (state: RootState) => state.services.filterParams
export const selectLastLoadedLocationId = (state: RootState) => state.services.lastLoadedLocationId

// Memoized selectors
export const selectServiceById = createSelector(
  [selectServices, (state: RootState, serviceId: string) => serviceId],
  (services, serviceId) => services.find(service => service.id === serviceId)
)

export const selectServicesByLocation = createSelector(
  [selectServices, (state: RootState, locationId: string) => locationId],
  (services, locationId) => services.filter(service => 
    service.shopLocations && service.shopLocations.some(location => location.id === locationId)
  )
)

export const selectServicesCount = createSelector(
  [selectServices],
  (services) => services.length
)
